export interface FaqItem {
  question: string;
  answer: string;
}

export const faqItems: FaqItem[] = [
  {
    question: '高柳家的历史有多久了？',
    answer: '高柳家创立于江户时代中期约公元1750年，至今已有超过270年的历史。我们已传承至第九代，每一代家主都在坚守核心价值的同时，为家族注入新的活力与创新。',
  },
  {
    question: '高柳家的核心理念是什么？',
    answer: '高柳家秉承"木有灵性，匠有心声"的家训精神，以匠心精研、文化传承、自然共生、生活美学为四大核心价值观。我们致力于在快速变化的时代中，守护并传承日本传统工艺的精髓。',
  },
  {
    question: '高柳家主要有哪些产品/服务？',
    answer: '高柳家旗下涵盖木工家具、茶道用具、香道器具、花道花器、天然染色纺织品、漆器等多个产品线。此外，我们还提供茶道体验课程、工艺研修班以及定制化空间设计服务。',
  },
  {
    question: '如何参观高柳家的工坊或体验店？',
    answer: '我们在京都市中京区三条通设有品牌体验店"高柳の舎"，营业时间为10:00至18:00（每周一定休）。工坊参观需提前预约，您可以通过官网的联系表单或致电+81-75-XXX-XXXX进行预约。',
  },
  {
    question: '高柳家的产品可以在线购买吗？',
    answer: '是的，高柳家官方线上商城已支持中、日、英、法四种语言，覆盖全球28个国家和地区。您可以在官网上浏览完整产品目录并进行在线购买，我们提供全球直邮配送服务。',
  },
  {
    question: '高柳家招收学徒吗？有什么要求？',
    answer: '高柳家每年通过"青年匠人培养计划"面向社会招收学员。我们欢迎对传统工艺有真挚热情的年轻人申请，不要求相关专业背景，但需要具备坚持不懈的学习态度和对匠人精神的尊重。详情请关注官网的招募公告。',
  },
  {
    question: '高柳家的茶道体验课程如何报名？',
    answer: '高柳家每年春、夏、秋、冬四季各举办一次公开茶会，同时每月设有小规模的茶道体验课程。您可以通过官网的预约系统或拨打电话进行报名，名额有限，建议提前一个月预约。',
  },
];